<script lang="ts" setup>
import { Form } from 'vee-validate';
import { registerFormStore } from '../model/FormStore';
import type { IFormProps } from '../types/Form';
const props = defineProps<IFormProps>();
const formRef = defineModel('formRef');
const formStore = registerFormStore(props);
</script>

<template>
  <Form :name="formStore.name" ref="formRef">
    <slot></slot>
  </Form>
</template>
